import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { SugaarLogo } from './SugaarLogo';
export function Hero() {
  return <section className="relative py-20 px-6 overflow-hidden" data-id="element-90">
      {/* Subtle gradient glow behind hero */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-91">
        <div className="w-[600px] h-[400px] bg-forest-light/20 rounded-full blur-[120px]" data-id="element-92" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-93">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="mb-8 flex justify-center" data-id="element-94">
          <img src="https://cdn.magicpatterns.com/uploads/1TBctBDvAmiiZJAM3NEhCH/dragon-icon---fire.svg" alt="Sugaar logo" className="w-20 h-28 object-contain" data-id="element-95" />
        </motion.div>

        {/* Brand Name */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-3 flex justify-center" data-id="element-96">
          <svg viewBox="0 0 200 50" className="w-full max-w-[280px]" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-97">
            <defs data-id="element-98">
              <linearGradient id="wordmarkFire" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-99">
                <stop offset="0%" stopColor="#D97642" data-id="element-100" />
                <stop offset="50%" stopColor="#C9563A" data-id="element-101" />
                <stop offset="100%" stopColor="#CC8F33" data-id="element-102" />
              </linearGradient>
            </defs>
            <text x="100" y="35" textAnchor="middle" fontFamily="system-ui, -apple-system, sans-serif" fontSize="36" fontWeight="600" fill="url(#wordmarkFire)" letterSpacing="-0.02em" data-id="element-103">
              Sugaar
            </text>
          </svg>
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-sm md:text-base text-parchment font-medium tracking-[0.3em] uppercase mb-6" data-id="element-104">
          Vibe Coding
        </motion.p>

        {/* Description */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-parchment text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-105">
          Transforming ideas into products through the power of AI-assisted
          creation. Like the shapeshifting serpent of legend, we embrace
          transformation.
        </motion.p>

        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-106">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-flame/10 border border-flame/30 rounded-full text-flame text-sm font-medium" data-id="element-107">
            <SparklesIcon className="w-4 h-4" data-id="element-108" />
            Available for collaborations
          </span>
        </motion.div>
      </div>
    </section>;
}